import { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";
import { Modal as AntModal, Spin } from "antd";
import { toast } from "react-toastify";

const PhysicalInventoryList = (props) => {
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getClosingStock } = useHttp();

  const getStock = () => {
    getClosingStock(
      {
        url: `/api/physicalInventory/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setData(res.output);
          setAllData(res.output);
        }
      }
    );
  };

  useEffect(() => {
    getStock();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.stockDailyClosingDate?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.warehouseName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    const physicalInventoryId = data && data.physicalInventoryId;

    getDetailView(
      {
        url: `/api/physicalInventory/?orgId=${localStorage.getItem(
          "orgId"
        )}&physicalInventoryId=${physicalInventoryId}`,
      },
      (res) => {
        console.log("Detail View", res);

        setSelectedData(res.output);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    setLoading(true);
    // console.log(approvalStatus);
    let data = "";
    if (approvalStatus === "approve") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.physicalInventoryId,
        approved: 1,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "disapprove") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.physicalInventoryId,
        approved: 2,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "sendNextApprove") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.physicalInventoryId,
        approved: 0,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 1,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    }

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/approvePhysicalInventory/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        getStock();
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <h4 className="card-title">Daily Closing Stock Details</h4>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsModalOpen(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>
        {selectedData && (
          <div>
            <div className="row">
              <p className="col-md-6">
                Physical Inventory Date:
                {selectedData && selectedData.physicalInventoryDate}
              </p>
              <p className="col-md-6">
                Employee Name : {selectedData && selectedData.employeeName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Warehouse Name : {selectedData && selectedData.warehouseName}
              </p>
            </div>

            <div className="row">
              <table className="table table-bordered table-responsive text-center">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th> Item Id </th>
                    <th>Product Name</th>
                    <th> Product Item Sub Type </th>
                    <th>Product Item Type </th>

                    <th> Quantity </th>
                    <th>Product Cost</th>
                    <th>Unit</th>

                    <th>Used Quantity</th>
                    <th>Amount</th>
                    <th>Physical Quantity</th>
                    <th>Amount</th>
                    <th>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.productData &&
                    selectedData.productData.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td> {itm.itemId} </td>

                          <td> {itm.productName} </td>

                          <td>{itm.productSubTypeName}</td>

                          <td> {itm.productTypeName} </td>

                          <td> {itm.quantity} </td>
                          <td>{itm.productCost}</td>
                          <td> {itm.unitAbbreviation} </td>

                          <td>{itm.totalUsedQuantity}</td>
                          <td>{itm.totalUsedProductCost}</td>
                          <td>{itm.physicalQuantity}</td>
                          <td>{itm.physicalProductCost}</td>
                          <td>{itm.remark}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Physical Inventory</label>
          </div>

          <div className="col-6 text-right">
          
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Physical Inventory
              </button>
            
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Employee Name</th>
                          <th>Warehouse</th>
                          <th>Approval</th>

                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.physicalInventoryDate}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.warehouseName}</td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.nextlevel == 1
                                        ? itm.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : itm.approved == 0 &&
                                          itm.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Physical Inventory Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("approve");
            }}
            disabled={loading}
          >
            {loading ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => {
              handleApprovalSubmit("disapprove");
            }}
            className="btn btn-sm btn-primary"
            disabled={loading}
          >
            {loading ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("sendNextApprove");
            }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default PhysicalInventoryList;
